var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgClassicSlotsFruitSlots = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2752V12.2788H17V12.2752V4.7248H0V12.2752ZM12.2211 6.64095H15.8615L14.4636 11.0965L13.5133 10.7983L14.5051 7.63705H13.2172V8.40835H12.2211V6.64095ZM6.76979 6.64095H10.4102L9.01266 11.0965L8.06205 10.7983L9.05383 7.63705H7.76588V8.40835H6.76979V6.64095ZM1.24412 6.64095H4.88451L3.48666 11.0965L2.53639 10.7983L3.52816 7.63705H2.24021V8.40835H1.24412V6.64095Z",
    fill: "#CCD6F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.48459H17V3.72871H0V2.48459Z",
    fill: "#CCD6F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2749V14.5154H17V13.2749V13.2713H0V13.2749Z",
    fill: "#CCD6F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClassicSlotsFruitSlots);
export default ForwardRef;